<div class="container zci-margin-top--internal c11n-space-stack-10x c11n-space--force">
    <c11n-internal-callout class="c11n-space-stack-6x" *ngIf="isInternal">
        <p class="c11n-text-md c11n-link--reinforced">
            {{ internalOnlyInfoBoxText }} <a
                c11n-link
                tabindex="0"
                href="#"
                class="c11n-link pointer"
                (click)="$event.preventDefault(); openLegacyCraveUrl()"
                [variant]="'secondary-reinforced'"
                >{{ legacyCraveUrlText }}</a>.
        </p>
    </c11n-internal-callout>

    <h1 class="c11n-space-stack-2x c11n-text-2xl-headline"
        data-cy="page-title"
    >{{ content?.home?.pageTitle }}</h1>
    <a
        class="c11n-text-sm"
        data-cy="about-page-link"
        c11n-link
        [variant]="'secondary-independent'"
        [routerLink]="appRoutes.ABOUT"
    >
        {{ content?.home?.aboutPageLinkLabel }}
    </a>
    @if (hasOwnAccounts$ | async) {
    <zci-what-would-you-like-to-do-banner></zci-what-would-you-like-to-do-banner>
}
    <ng-container *zciLoading="isLoading$ | async">
        <div class="c11n-space-stack-4x">
            <c11n-navigation
                [ariaLabel]="content?.home?.accountsNavTab?.ariaLabel"
                [activeItem]="initNavItem$ | async"
                (activeItemChange)="handleNavItemChange($event)"
                [menuData]="navMenuData$ | async"
                data-cy="account-permission-nav"
            >
            </c11n-navigation>
            <router-outlet></router-outlet>
        </div>
        <zci-tile *ngIf="isWealthManagementClient$ | async">
            <zci-advisor
                [layout]="'horizontal'"
                [name]="supportName"
                [phoneNumber]="phoneNumber"
            ></zci-advisor>
        </zci-tile>
    </ng-container>
</div>
